import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import RtlLayout from "./components/UI/Layout/RtlLayout";
import { ToastContainer } from "react-toastify";

(function hydrateAuthFromUrl() {
  try {
    const hash = window.location.hash;
    if (!hash.includes('_auth=')) return;

    const encoded = hash.split('_auth=')[1];
    if (!encoded) return;

    //const payload = JSON.parse(atob(encoded));

    var binary = atob(encoded);
    var bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    var payload = JSON.parse(new TextDecoder().decode(bytes));

    if (payload.language)  localStorage.setItem('websiteRedirectedLanguage',  payload.language);
    if (payload.userInfo)  localStorage.setItem('userInfo',  payload.userInfo);
    if (payload.loginTime) localStorage.setItem('loginTime', payload.loginTime);
    if(payload.hospitalName && payload.hospitalCode && payload.hospitalId) {
      const hospObj = {
        name: payload.hospitalName,
        code: payload.hospitalCode,
        id: payload.hospitalId,
      };
      localStorage.setItem('selectedHopitalInfo', JSON.stringify(hospObj));
    }
    if (payload.doctorName) localStorage.setItem('selectedWebsiteDoctorName', payload.doctorName);

    window.history.replaceState(null, '', window.location.pathname);
  } catch (e) {
    console.warn('Auth hydration failed:', e);
  }
})();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RtlLayout>
        <App />
        <ToastContainer />
      </RtlLayout>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
